import { render, staticRenderFns } from "./MagazzinoMagazziniListComponent.vue?vue&type=template&id=0673b46e"
import script from "./MagazzinoMagazziniListComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoMagazziniListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports